import { render } from "./configFormulaComponent.vue?vue&type=template&id=69d6f098&scoped=true"
import script from "./configFormulaComponent.vue?vue&type=script&lang=js"
export * from "./configFormulaComponent.vue?vue&type=script&lang=js"

import "./configFormulaComponent.vue?vue&type=style&index=0&id=69d6f098&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d6f098"]])

export default __exports__